import { render, staticRenderFns } from "./Rekisteroi-yritys.vue?vue&type=template&id=cae28b18&"
import script from "./Rekisteroi-yritys.vue?vue&type=script&lang=js&"
export * from "./Rekisteroi-yritys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports